let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hs6oN")).then(() => parcelRequire('agyc8'));